import React from 'react';
import PropTypes from 'prop-types';
import {
    WeezHeader,
    Card,
    PreviewCard,
    Tab,
    OptionalForm,
    SplitContainer,
    Input,
    Form,
    ColorPicker,
    Button,
    RadioLabel,
    Select,
    Section,
    TooltipHelp,
    Counter,
    TextArea,
    CheckboxLabel,
    ToastContext
} from '@weezevent/nacre';

import Style from './sell-on-site.module.css';

import { useTranslation } from 'react-i18next';
import { getLanguageOptions } from '../../../nacre/components/LanguageSelector';
import { WidgetPreview } from '../../widgets/components/pages/new-widget';

function PreviewButtonWidget({ widgetUrl = null, buttonTextColor, buttonColor, textButton }) {
    const { t } = useTranslation();
    let widgetUrlPreview = `${widgetUrl}#weez_preview`;

    return (
        <PreviewCard
            // className={Style['preview-card']}
            title={t('ticket.sell_on_my_site.title_preview_button')}
            ellipsis
            onClick={() => window.open(`${widgetUrlPreview}`, '_blank')}
        >
            {widgetUrl && (
                <div style={{ 'text-align': 'center', margin: '50px auto', width: 'fit-content' }}>
                    <p
                        onClick={() => {
                            window.open(`${widgetUrlPreview}`);
                        }}
                        style={{ 'border-radius': '5px', 'text-decoration': 'none', color: buttonTextColor, background: buttonColor, padding: '.4em 1em' }}
                    >
                        {textButton}
                    </p>
                </div>
            )}
        </PreviewCard>
    );
}

export default function SellOnSite({ event, organization }) {
    const { t } = useTranslation();
    const toast = React.useContext(ToastContext);

    const [activeTab, setActive] = React.useState(0);
    const [textButton, setTextButton] = React.useState(t('ticket.sell_on_my_site.card_button.buyTicket'));
    const [buttonColor, setButtonColor] = React.useState('#0032fa');
    const [buttonTextColor, setButtontextColor] = React.useState('#ffffff');
    const [Visibility, setVisibility] = React.useState(false);
    const [primaryColor, setPrimaryColor] = React.useState('#0032FA');
    const [language, setlanguage] = React.useState(event.default_language.split('-')[0] + '-' + event.default_language.split('-')[1].toUpperCase());
    const [origin, setOrigin] = React.useState('');

    const [width, setWidth] = React.useState(650);
    const [height, setHeight] = React.useState(600);
    const [autoWidth, setAutoWidth] = React.useState(true);
    const [autoHeight, setAutoHeight] = React.useState(true);

    const widgetUrl = React.useMemo(() => {
        return `${window.weezConfig.api.widgetUrl}/ticket/E${event.id}/?code=${
            event.default_widget_access_code
        }&locale=${language}&width_auto=1&color_primary=${primaryColor.substring(1)}`;
    }, [event, language, primaryColor]);

    const generateModuleCodeToCopy = React.useCallback(() => {
        const dataSrcURL = `${widgetUrl}${origin ? '&o=' + encodeURI(origin) : ''}`;
        let code =
            `<a title="Logiciel billetterie en ligne"\n href="${dataSrcURL}"\n class="weezevent-widget-integration"\n ` +
            `data-src="${dataSrcURL}"\n ` +
            (Visibility ? `data-width="${width}"\n data-height="${height}"\n ` : ' ') +
            `data-id="${event.id}"\n data-resize="${autoHeight ? 1 : 0}"\n data-width_auto="${
                autoWidth ? 1 : 0
            }"\n data-noscroll="0"\n data-use-container="yes"\n data-type="neo"\n `;
        if (origin) code += `  data-o="${encodeURI(origin)}"\n `;

        code += `target="_blank">Billetterie Weezevent</a>\n<script type="text/javascript" src="${window.weezConfig.api.widgetUrl}/weez.js"></script>`;
        return code;
    }, [widgetUrl, Visibility, width, height, autoHeight, origin, event]);

    const generateButtonCodeToCopy = React.useCallback(() => {
        let code = `<a href="${widgetUrl}" onclick="var w=window.open('${widgetUrl}', 'Billetterie_weezevent', 'width=650, height=600, top=100, left=100, toolbar=no, resizable=yes, scrollbars=yes, status=no'); w.focus(); return false;" style="text-decoration: none;color: ${buttonTextColor};background: ${buttonColor};padding: .4em 1em;border-radius: 5px;">${textButton}</a>`;
        return code;
    }, [widgetUrl, buttonTextColor, buttonColor, textButton]);

    /*À remplacer avec les langues*/
    const dropItem = getLanguageOptions().filter(opt => {
        if (opt.value === 'it-IT' && event.languages.includes('it')) {
            opt.value = 'it';
            return true;
        }
        return event.languages.includes(opt.value.toLowerCase());
    });

    const panes = [
        {
            menuItem: t('ticket.sell_on_my_site.labelEditModule'),
            menuIcon: 'windows',
            render: () => <></>
        },
        {
            menuItem: t('ticket.sell_on_my_site.labelEditButton'),
            menuIcon: 'windows-open',
            render: () => <></>
        }
    ];

    return (
        <div className={Style['sell-on-site__container']}>
            <WeezHeader title={t('ticket.sell_on_my_site.title')}>{t('ticket.sell_on_my_site.sub')}</WeezHeader>
            <SplitContainer
                size="maxi"
                additional={
                    activeTab === 0 ? (
                        <WidgetPreview widgetUrl={widgetUrl} title={t('ticket.sell_on_my_site.title_preview_module')} />
                    ) : (
                        <PreviewButtonWidget widgetUrl={widgetUrl} buttonTextColor={buttonTextColor} buttonColor={buttonColor} textButton={textButton} />
                    )
                }
            >
                <Tab
                    activeTab={activeTab}
                    panes={panes}
                    onTabSelected={(tab, idx) => {
                        setActive(idx);
                    }}
                >
                    {activeTab === 0 ? (
                        <Card>
                            <Card.Header>
                                <Card.Title title={t('ticket.sell_on_my_site.card_module.title')} />
                                <Card.SubTitle title={t('ticket.sell_on_my_site.card_module.sub')} />
                            </Card.Header>
                            <Card.Content>
                                <div style={{ display: 'flex', 'align-items': 'center' }}>
                                    <ColorPicker value={primaryColor} onChange={(synth, value) => setPrimaryColor(value)} />
                                    <span style={{ marginLeft: '6px' }}>{t('ticket.sell_on_my_site.card_module.primaryColor')}</span>
                                </div>

                                <Form style={{ 'margin-top': '15px' }}>
                                    <Form.Label label={t('ticket.sell_on_my_site.card_module.labelSize')} />
                                    <RadioLabel
                                        name="dimensions"
                                        value="default"
                                        inline
                                        bordered
                                        defaultChecked
                                        onClick={() => {
                                            setVisibility(false);
                                            setAutoHeight(true);
                                            setAutoWidth(true);
                                        }}
                                    >
                                        {t('ticket.sell_on_my_site.radio_label1')}
                                    </RadioLabel>
                                    <RadioLabel
                                        name="dimensions"
                                        value="custom"
                                        inline
                                        bordered
                                        onClick={() => {
                                            setVisibility(true);
                                            setAutoHeight(false);
                                            setAutoWidth(false);
                                        }}
                                    >
                                        {t('ticket.sell_on_my_site.radio_label2')}
                                    </RadioLabel>
                                    {Visibility && (
                                        <Section>
                                            <>
                                                <div style={{ marginTop: '15px', marginBottom: '5px' }}>{t('ticket.sell_on_my_site.card_module.width')}</div>
                                                <div className={Style['counter-and-checkbox']}>
                                                    <Counter disabled={autoWidth} onChange={(event, value) => setWidth(value)} step={1} value={width} />
                                                    <CheckboxLabel
                                                        name="checkboxA"
                                                        inverted
                                                        label={t('ticket.sell_on_my_site.automatic')}
                                                        checked={autoWidth}
                                                        onChange={() => {
                                                            setAutoWidth(!autoWidth);
                                                        }}
                                                    />
                                                </div>

                                                <div style={{ marginTop: '15px', marginBottom: '5px' }}>{t('ticket.sell_on_my_site.card_module.height')}</div>
                                                <div className={Style['counter-and-checkbox']}>
                                                    <Counter disabled={autoHeight} onChange={(event, value) => setHeight(value)} step={1} value={height} />
                                                    <CheckboxLabel
                                                        name="checkboxA"
                                                        inverted
                                                        label={t('ticket.sell_on_my_site.automatic')}
                                                        checked={autoHeight}
                                                        onChange={() => {
                                                            setAutoHeight(!autoHeight);
                                                        }}
                                                    />
                                                </div>
                                            </>
                                        </Section>
                                    )}
                                    <div style={{ marginTop: '15px', marginBottom: '5px' }}>{t('ticket.sell_on_my_site.card_module.langue')}</div>
                                    <Select value={language} onChange={setlanguage} options={dropItem} />
                                    <div style={{ marginTop: '15px', marginBottom: '5px' }}>
                                        <span>{t('ticket.sell_on_my_site.card_module.originLabel')}</span>
                                        <TooltipHelp title={t('ticket.sell_on_my_site.card_module.origin_help')} />
                                        <span className={Style['optional']}>{t('ticket.sell_on_my_site.card_module.originOption')}</span>
                                    </div>
                                    <Input value={origin} maxLength={20} onChange={event => setOrigin(event.target.value.replace(' ', ''))} />
                                    <>
                                        <Button
                                            style={{ marginTop: '15px' }}
                                            color="ticket"
                                            onClick={async () => {
                                                if (!navigator.clipboard) {
                                                    toast.error(t('ticket.sell_on_my_site.copyToastError'));
                                                    return;
                                                }
                                                try {
                                                    await navigator.clipboard.writeText(generateModuleCodeToCopy());
                                                    toast.success(t('ticket.sell_on_my_site.copyToastSuccess'));
                                                } catch (err) {
                                                    toast.error(t('ticket.sell_on_my_site.copyToastError'));
                                                }
                                            }}
                                            label={t('ticket.sell_on_my_site.label_copy_button')}
                                            primary
                                        />
                                    </>
                                </Form>
                            </Card.Content>
                        </Card>
                    ) : (
                        <Card>
                            <Card.Header>
                                <Card.Title title={t('ticket.sell_on_my_site.card_button.title')} />
                                <Card.SubTitle title={t('ticket.sell_on_my_site.card_button.sub')} />
                            </Card.Header>
                            <Form style={{ padding: '15px' }}>
                                <Form.Label label="Texte du bouton" />
                                <Input placeholder="An input with size" value={textButton} onChange={event => setTextButton(event.target.value)} />
                                <div style={{ marginTop: '15px', display: 'flex', 'align-items': 'center' }}>
                                    <ColorPicker label="ooui" value={buttonColor} onChange={(synth, value) => setButtonColor(value)} />
                                    <span style={{ marginLeft: '6px' }}>{t('ticket.sell_on_my_site.card_button.buttonColor')}</span>
                                </div>
                                <div style={{ marginTop: '15px', display: 'flex', 'align-items': 'center' }}>
                                    <ColorPicker label="ooui" value={buttonTextColor} onChange={(synth, value) => setButtontextColor(value)} />
                                    <span style={{ marginLeft: '6px' }}>{t('ticket.sell_on_my_site.card_button.buttonTextColor')}</span>
                                </div>

                                <Button
                                    color="ticket"
                                    onClick={async () => {
                                        if (!navigator.clipboard) {
                                            toast.error(t('ticket.sell_on_my_site.copyToastError'));
                                            return;
                                        }
                                        try {
                                            await navigator.clipboard.writeText(generateButtonCodeToCopy());
                                            toast.success(t('ticket.sell_on_my_site.copyToastSuccess'));
                                        } catch (err) {
                                            toast.error(t('ticket.sell_on_my_site.copyToastError'));
                                        }
                                    }}
                                    label={t('ticket.sell_on_my_site.label_copy_button')}
                                    primary
                                    style={{ marginRight: '20px', marginTop: '20px' }}
                                />
                            </Form>
                        </Card>
                    )}
                </Tab>
                <OptionalForm open={false} labelOpen={t('ticket.sell_on_my_site.codeOpen')} labelClosed={t('ticket.sell_on_my_site.codeClose')}>
                    <Card.FormStep title={t('ticket.sell_on_my_site.codeTitle')} subtitle={t('ticket.sell_on_my_site.codeSub')}>
                        <TextArea
                            disabled
                            style={{ color: '#878c9b', resize: 'none', transition: 'none' }}
                            value={activeTab === 0 ? generateModuleCodeToCopy() : generateButtonCodeToCopy()}
                        />
                    </Card.FormStep>
                </OptionalForm>
            </SplitContainer>
        </div>
    );
}

SellOnSite.propTypes = {
    organization: PropTypes.object.isRequired,
    event: PropTypes.object.isRequired
};
